
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    items.forEach(el => io.observe(el));
  });


document.addEventListener('DOMContentLoaded', () => {
  const els = Array.from(document.querySelectorAll('.parallax'));
  if (!els.length) return;

  function onScroll() {
    const isMobile = window.innerWidth <= 767;

    els.forEach(el => {
      if (isMobile && el.classList.contains('parallax--no-mobile')) {
        el.style.transform = 'none';
        return;
      }

      const speedAttr = el.getAttribute('data-speed');
      const speed     = speedAttr ? parseFloat(speedAttr) : 0.3;
      const direction = el.getAttribute('data-direction') || 'up';

      const parent = el.closest('section') || el.parentElement;
      const rect   = parent.getBoundingClientRect();

      const offsetY = (window.innerHeight / 2) - (rect.top + rect.height / 2);
      const offsetX = (window.innerWidth  / 2) - (rect.left + rect.width  / 2);

      let x = 0, y = 0;

      switch (direction) {
        case 'up':    y = -offsetY * speed; break;
        case 'down':  y =  offsetY * speed; break;
        case 'left':  x = -offsetX * speed; break;
        case 'right': x =  offsetX * speed; break;
      }

      el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
});

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.section__reveal');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('section__visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  elements.forEach(el => observer.observe(el));
});








(() => {
  const SELECTOR = '[data-reveal], .reveal';

  function revealInit(root = document) {
    const els = Array.from(root.querySelectorAll(SELECTOR))
      .filter(el => !el.dataset.revealBound);

    if (!els.length) return;

    // mark + prep
    els.forEach((el, i) => {
      el.dataset.revealBound = "1";
      el.classList.add("reveal");
      if (!el.style.getPropertyValue("--reveal-delay")) {
        // default stagger: data-stagger groups + cap at 700ms
        const stagger = Number(el.dataset.stagger ?? 90);
        el.style.setProperty("--reveal-delay", `${Math.min(i * stagger, 700)}ms`);
      }
    });

    // fallback
    if (!("IntersectionObserver" in window)) {
      els.forEach(el => el.classList.add("is-revealed"));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        const el = entry.target;
        el.classList.add("is-revealed");

        // reveal once by default
        if (el.dataset.revealOnce !== "false") io.unobserve(el);
      }
    }, {
      threshold: 0.12,
      rootMargin: "0px 0px -10% 0px"
    });

    els.forEach(el => io.observe(el));
  }

  // initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => revealInit(document));
  } else {
    revealInit(document);
  }

  // Shopify section events (theme editor + dynamic loads)
  document.addEventListener("shopify:section:load", (e) => revealInit(e.target));
  document.addEventListener("shopify:section:reorder", () => revealInit(document));

  // If content is injected (apps), observe DOM mutations lightly
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) revealInit(node);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


